var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "available-providers-item" },
    [
      _c("h4", { staticClass: "fs-4 mt-0 mb-3" }, [
        _vm._v(_vm._s(_vm.provider.type))
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "provider-label" }, [
        _vm.provider.icon
          ? _c(
              "div",
              { staticClass: "provider-label__icon" },
              [_c("icon-" + _vm.provider.icon, { tag: "component" })],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c("h5", { staticClass: "provider-label__text m-0 bold" }, [
          _vm._v("\n            " + _vm._s(_vm.provider.label) + "\n        ")
        ])
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "fs-3 mt-2 mb-3" }, [
        _vm._v(_vm._s(_vm.provider.description))
      ]),
      _vm._v(" "),
      _c("CompassButton", {
        attrs: {
          label: _vm.provider.button,
          type: _vm.isGoogleAuthenticator(_vm.provider)
            ? "primary"
            : "secondary"
        },
        on: {
          click: function($event) {
            return _vm.activateProvider(_vm.provider)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }